import Expand from "@arcgis/core/widgets/Expand.js";
import { createUpdateModal } from "./updateModal";
import { createGuideModal } from "./guideModal";
import { createInternalUpdateModal } from "./internalUpdateModal";

export default async function(WinGISMap, type) {
  if (type == "public")
  {
    createUpdateModal();
  }
  else if (type == "wan") {
    createInternalUpdateModal();
  }
  createGuideModal(); 
  let sidebarWidth;
  let sidebarExpand = document.createElement("calcite-button");
  sidebarExpand.kind = "neutral";
  sidebarExpand.id = "sidebarExpand";
  sidebarExpand.iconStart = "chevrons-left";
  sidebarExpand.classList.add("esri-component", "esri-expand", "esri-widget");

  // Wait for the map view to be ready
  //await WinGISMap.view.when();

  // Add the sidebar expand button to the view
  WinGISMap.view.ui.add({ component: sidebarExpand, position: "top-left", index: 7 });

  let collapseButton;
  let expandedSidebar;
  let width;
  let viewDivshrink;

  let toggleSidebar = (viewDivshrink, expandedSidebar) => {
    width = window.innerWidth;
    if (width > 1024) {
      viewDivshrink = "70%";
      expandedSidebar = "30%";
    } else if (width > 768) {
      viewDivshrink = "60%";
      expandedSidebar = "40%";
    } else if (width > 375) {
      viewDivshrink = "25%";
      expandedSidebar = "75%";
    } else {
      viewDivshrink = "20%";
      expandedSidebar = "80%";
    }

    const sidebar = document.getElementById("sidebar");
    const viewDiv = document.getElementById("viewDiv");

    if (sidebar.classList.contains("collapsed")) {
      sidebarExpand.iconStart = "chevrons-left";
      sidebar.style.width = expandedSidebar;
      sidebarWidth = sidebar.style.width;
      sidebar.style.marginLeft = "0%";
      viewDiv.style.width = viewDivshrink;
      sidebar.classList.remove("collapsed");
    } else {
      sidebarExpand.iconStart = "chevrons-right";
      sidebarWidth = sidebar.style.width;
      sidebar.style.marginLeft = `-${sidebarWidth}`;
      sidebar.classList.add("collapsed");
      viewDiv.style.width = "100%";
    }
    return sidebarWidth;
  };

  let sidebar = document.getElementById("sidebar");
  let viewDiv = document.getElementById("viewDiv");
  sidebarExpand.addEventListener("click", () => {
    sidebarWidth = toggleSidebar(viewDivshrink, expandedSidebar);
  });
  toggleSidebar(viewDivshrink, expandedSidebar);

  // Handle tab pane activation
  let activeTabs = document.querySelectorAll(".active.tab-pane");
  let tabs = document.querySelectorAll(".tab-pane");
  if (activeTabs.length > 0) {
    activeTabs.forEach((element) => {
      element.classList.remove("active", "show");
    });
  }

  if (tabs.length > 0) {
    tabs[0].classList.add("active", "show");
  }
}
